export default __webpack_public_path__ + "static/media/guides-logo.d3a30ea1.png";